import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ITEM_PRICE_LIST_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createItemPriceListAction = createAsyncThunk(
    'price/createItemPriceListAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ ITEM_PRICE_LIST_PATH }/${ data.productId }/price-list/${ data.priceListId }?basicGrossPrice=${ data.basicGrossPrice }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createItemPriceListSlice = createSlice({
    name: 'createItemPriceListSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createItemPriceListAction.pending, () => STATE__API__STARTED);
        builder.addCase(createItemPriceListAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createItemPriceListAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createItemPriceListState = (state) => state.price.createItemPriceList;
export default createItemPriceListSlice.reducer;
